import HeroImage from "./HeroImage"

import TestsMainButton from "./TestsMainButton"

import Styles from "./Hero.module.scss"

export default function TestsHero({
  h1Description,
  h1Content,
  subTitle,
  buttonText,
  buttonAction,
  imageAlt,
  imageUrl,
}) {
  return (
    <>
      <div className={Styles.Hero} id="page-wrap">
        <div className={Styles.HeroMainTextWrapper}>
          <h1 className={Styles.HeroMainText}>{h1Content}</h1>
          <div className={Styles.HeroDescriptionText}>{h1Description}</div>
        </div>

        <div className={Styles.HeroVideoAndCTA}>
          <HeroImage alt={imageAlt} url={imageUrl} />

          <h2 className="text-black hidden lg:block mt-10 text-2xl">
            {subTitle}
          </h2>

          <TestsMainButton text={buttonText} action={buttonAction} />
        </div>
      </div>
    </>
  )
}
